/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Withdrawal } from './Withdrawal';
import {
    WithdrawalFromJSON,
    WithdrawalFromJSONTyped,
    WithdrawalToJSON,
} from './Withdrawal';

/**
 * 
 * @export
 * @interface WithdrawalPage
 */
export interface WithdrawalPage {
    /**
     * 
     * @type {number}
     * @memberof WithdrawalPage
     */
    totalNr: number;
    /**
     * 
     * @type {Array<Withdrawal>}
     * @memberof WithdrawalPage
     */
    withdrawals: Array<Withdrawal>;
    /**
     * 
     * @type {string}
     * @memberof WithdrawalPage
     */
    asOfDate: string;
}

/**
 * Check if a given object implements the WithdrawalPage interface.
 */
export function instanceOfWithdrawalPage(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "totalNr" in value;
    isInstance = isInstance && "withdrawals" in value;
    isInstance = isInstance && "asOfDate" in value;

    return isInstance;
}

export function WithdrawalPageFromJSON(json: any): WithdrawalPage {
    return WithdrawalPageFromJSONTyped(json, false);
}

export function WithdrawalPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): WithdrawalPage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalNr': json['total_nr'],
        'withdrawals': ((json['withdrawals'] as Array<any>).map(WithdrawalFromJSON)),
        'asOfDate': json['as_of_date'],
    };
}

export function WithdrawalPageToJSON(value?: WithdrawalPage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total_nr': value.totalNr,
        'withdrawals': ((value.withdrawals as Array<any>).map(WithdrawalToJSON)),
        'as_of_date': value.asOfDate,
    };
}

